<template>
  <page-view title="精选联盟账户">
    <div :style="{ marginBottom: '10px' }">
      <demo-video-alert name="LianMengPeiZhi"></demo-video-alert>
    </div>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="查询条件">
                <a-select v-model="queryParam.type" placeholder="请选择查询条件" allowClear>
                  <a-select-option value="1">账户ID</a-select-option>
                  <a-select-option value="2">抖Y联盟账户</a-select-option>
                  <a-select-option value="3">备注信息</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="查询内容">
                <a-input v-model="queryParam.keywords" placeholder="请输入查询内容" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="授权状态">
                <a-select v-model="queryParam.status" placeholder="请选择授权状态" allowClear>
                  <a-select-option value="1">已授权</a-select-option>
                  <a-select-option value="2">已过期</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <template v-if="advanced"></template>
            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}">
                <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
                <a-button style="margin-left: 8px" @click="() => (queryParam = {})">重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <div class="table-operator">
        <a-button type="primary" @click="handleAdd()">新增精选联盟账户</a-button>
        <!-- <a-button type="primary" @click="()=>{$message.error('暂未开放')}" disabled>新增抖Y联盟</a-button> -->
        <a-button type="primary" @click="casflag"> 提现 </a-button>
        <a-button type="primary" @click="() => { $message.error('暂未开放') }" disabled>查看明细 </a-button>
        <div class="commission">
          <p>本月预估/上月预估/可提现余额</p>
          <p>{{ theMonthCommission }} / {{ lastMonthCommission }} / {{ dyBalance / 100 }}</p>
        </div>
        <div class="alert">
          <a-alert description="重要提醒！！！！个人授权填写cookie后请不要再次退出登录达人后台账号，以防cookie失效" type="warning" />
        </div>
      </div>

      <s-table ref="table" size="default" rowKey="authority_id" :columns="columns" :data="loadData">
        <div slot="remark" slot-scope="text, record">{{ record.remark ? record.remark : '无' }}</div>
        <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
        <!-- <span slot="robot_num" slot-scope="text">
          <a>{{ text }}</a>
        </span> -->
        <span slot="cookie" slot-scope="record">
          {{ record | cookie }}
        </span>
        <span slot="status" slot-scope="record">
          <a-badge :status="record.status | statusTypeFilter" :text="record.status | statusFilter" />
        </span>
        <span slot="is_sync" slot-scope="text, record">
          <a-switch checked-children="开" un-checked-children="关" :default-checked="text == 2"
            @change="e => handleSysChange(e, record)" />
        </span>
        <span slot="time" slot-scope="text">{{ text }}</span>
        <span slot="action" slot-scope="text, record">
          <span v-if="record.authority_id != '官方共享'">
            <a @click="copyText(record.access_token)">复制授权</a>
            <a-divider type="vertical" />
          </span>
          <a-popconfirm placement="top" @confirm="handleDelete(record.authority_id)">
            <template slot="title">
              <p>确定要删除？</p>
              <span>删除后机器人相关功能将失效！</span>
            </template>
            <a>删除账户</a>
          </a-popconfirm>
          <a-divider type="vertical" />
          <!-- <a @click="$refs.editModal.show(record)">更新授权</a> -->
          <!-- <a @click="update(record)">更新授权</a> -->
          <a v-if="record.authority_id!='官方共享'" @click="positionSync(record)">设置自定义推广位同步</a>
          <a-divider type="vertical" />
          <a-tooltip placement="topLeft">
            <template slot="title">
              <div style="position: relative;text-align: right;">
                <p style="width:200px;text-align: left;">系统会在授权过期前半小时内自动更新授权，如您手动更新时，距离授权过期时间大于1小时，授权过期时间不会刷新</p>
                <a-button size="small" type="primary" @click="update(record)">更新授权</a-button>
              </div>
            </template>
            <a>更新授权</a>
          </a-tooltip>
        </span>
      </s-table>

    </a-card>

    <!-- <edit-modal ref="editModal" @ok="$refs.table.refresh()"></edit-modal> -->
    <add-modal ref="addModal" @ok="$refs.table.refresh(true)"></add-modal>

    <!-- 可提现余额 -->
    <a-modal :visible="balanceVisible" :width="700" title="可提现余额" ok-text="确认" cancel-text="取消" @ok="cashWithdrawal"
      @cancel="casflag">
      <p style="text-align: center;">当前可提现余额：{{ dyBalance / 100 }}，扣除10%技术服务费（抖音官方扣除），实际到账：{{ dyBalance | dyBalanceFilter
      }}</p>
      <!-- <p style="text-align: center;">当前可提现余额：{{ dyBalance / 100 }}，扣除10%技术服务费（抖音官方扣除），实际到账：{{ dyBalance / 100 * 0.9 }}</p> -->
      <a-form :form="balanceForm" @submit="cashWithdrawal">
        <a-form-item label="姓名" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['user_name', { rules: [{ required: true, message: '必填项' }] }]" />
        </a-form-item>
        <a-form-item label="手机号/邮箱" help="请输入支付宝绑定的手机号或者邮箱" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['user_phone', { rules: [{ required: true, message: '必填项' }] }]" />
        </a-form-item>
      </a-form>
    </a-modal>

    <!-- 	设置自定义推广位同步 -->
    <custom-promotion-space ref="cpSpace"></custom-promotion-space>

  </page-view>
</template>

<script>
import AddModal from './AddModal'
import { STable } from '@/components'
import CompanyApi from '@/api/company'
import { PageView } from '@/layouts'
import { mapGetters, mapActions } from 'vuex'
// import EditModal from './modules/EditModal'
import CustomPromotionSpace from './modules/CustomPromotionSpace'

import DemoVideoAlert from '@/views/components/DemoVideoAlert'
import { getInfo } from '@/api/login'
import { conforms } from 'lodash'

const statusMap = {
  1: {
    status: 'processing',
    text: '正常',
  },
  3: {
    status: 'error',
    text: '已过期',
  },
}

export default {
  name: 'CompanyTaobaoList',
  components: {
    PageView,
    STable,
    // EditModal,
    DemoVideoAlert,
    AddModal,
    CustomPromotionSpace,
  },
  data() {
    return {
      isSync: 0,
      // 上月预估
      lastMonthCommission: 0,
      // 本月预估
      theMonthCommission: 0,
      // 可提现余额
      dyBalance: 0,
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      expire_time: '',
      // 表头
      columns: [
        {
          title: '序号',
          scopedSlots: { customRender: 'serial' },
        },
        {
          title: '	抖音id',
          dataIndex: 'authority_id',
        },
        // {
        //   title: 'cookie',
        //   dataIndex: 'cookie',
        //   scopedSlots: { customRender: 'cookie' },
        // },
        // {
        //   title: '授权状态',
        //   scopedSlots: { customRender: 'status' },
        // },
        {
          title: '同步订单',
          dataIndex: 'is_sync',
          scopedSlots: { customRender: 'is_sync' },
        },
        // {
        //   title: '备注信息',
        //   scopedSlots: { customRender: 'remark' },
        // },
        {
          title: 'AccessToken',
          // scopedSlots: { customRender: 'time' },
          dataIndex: 'access_token',
        },
        {
          title: '过期时间',
          //  scopedSlots: { customRender: 'time' },
          dataIndex: 'expires_in',
          sorter: true,
        },
        {
          title: '操作',
          width: '250px',
          scopedSlots: { customRender: 'action' },
        },
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return CompanyApi.getDouyinCookieList(Object.assign(parameter, this.queryParam)).then(res => {
          if (res.data.length > 1) {
            res.data.forEach((item, index) => {
              if (index != 0) {
                item.expires_in = this.timestampToTime(item.expires_in)
              }
            })
          }
          return res
        })
      },
      // （可提现余额）提现
      balanceForm: this.$form.createForm(this), // 余额
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      },
      balanceVisible: false, // 余额弹框
    }
  },
  filters: {
    cookie(value) {
      return '*****'
    },
    statusFilter(expire_time) {
      // const curTimestamp = new Date().getTime()
      // let type
      // if (expire_time > curTimestamp) {
      //   type = 1
      // } else {
      //   type = 3
      // }
      return statusMap[1].text
    },
    statusTypeFilter(expire_time) {
      // const curTimestamp = new Date().getTime()
      // // let type
      // // if (expire_time > curTimestamp) {
      // //   type = 1
      // // } else {
      // //   type = 3
      // // }
      return statusMap[1].status
    },
    // 可提现余额(第三位小数，四舍五入，如：123.456，即：123.46)
    dyBalanceFilter(value) {
      // console.log('可提现余额=', value)
      value = value / 100 * 0.9
      let resNum = parseFloat(value)
      if (isNaN(resNum)) {
        console.log('function:changeTwoDecimal->parameter error')
        return false
      }
      resNum = Math.round(resNum * 100) / 100
      return resNum
    }
  },
  created() {
    this.getDouyinList()
    this.getData()
  },
  methods: {
    ...mapActions(['demoSetVideo']),
    ...mapGetters(['userInfo']),

    // 复制授权
    copyText(text) {
      this.$copyText(text).then(() => {
        this.$message.success('复制成功')
      }).catch((e) => {
        console.log(e)
        this.$message.error('复制失败')
      })
    },

    // 将时间戳转换成日期格式
    timestampToTime(value) {
      var date = new Date(value * 1000) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + '-'
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
      var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
      var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
      var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
      var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      return Y + M + D + h + m + s
    },

    update(data) {
      if (data.authority_id === '官方共享') {
        this.$message.error('暂不支持修改')
        return
      } else {
        CompanyApi.updateDouyin({ pageSize: 10, pageNo: 1 }).then(res => {
          this.handleAdd()
          if (res.code === 1) {
            this.$message.success('操作成功')
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },

    handleAdd() {
      const id = this.userInfo().id
      window.open('https://buyin.jinritemai.com/dashboard/institution/through-power?app_id=7114195867204077064&state=Nature_' + id + '&view=web')
      const that = this
      this.$confirm({
        title: '请在新窗口中登录抖音账户完成授权',
        okText: '已完成授权',
        cancelText: '关闭',
        onOk() {
          that.$refs.table.refresh(true)
        },
      })
    },

    getData() {
      getInfo()
        .then(res => {
          if (res.code === 1) {
            this.dyBalance = res.data.operate_info.dy_balance
          } else {
            this.$message.error(res.msg)
          }
        })
    },

    toggleAdvanced() {
      this.advanced = !this.advanced
    },

    // 获取官方的本月预估与上月预估
    getDouyinList() {
      CompanyApi.getDouyinList({})
        .then(res => {
          const { data } = res
          this.lastMonthCommission = data.last_month_commission
          this.theMonthCommission = data.the_month_commission
        })
    },

    async handleSysChange(e, data) {
      if (data.authority_id === '官方共享') {
        return
      }
      if (e) {
        this.isSync = 2
      } else {
        this.isSync = 0
      }
      CompanyApi.addDouyin({
        cookie: data.cookie,
        remark: data.remark,
        authority_id: data.authority_id,
        is_sync: this.isSync,
      })
        .then(res => {
          if (res.code === 1) {
            // this.form.resetFields()
            this.$message.success('设置成功')
            this.visible = false
            this.$emit('ok')
          } else {
            this.$message.error(res.msg)
          }
        })
        .finally(() => {
          this.confirmLoading = false
          this.$refs.table.refresh(true)
        })
    },

    handleDelete(authority_id) {
      let loading = this.$message.loading('正在删除')
      CompanyApi.deleteDouyin({ authority_id: authority_id })
        .then(res => {
          if (res.code === 1) {
            this.$message.success('删除成功')
            this.$refs.table.refresh()
          } else {
            this.$message.error(res.msg)
          }
        })
        .finally(() => {
          this.$message.destroy(loading)
        })
    },

    // 是否展示“ 提现 ”的弹框
    casflag() {
      this.balanceVisible = !this.balanceVisible
    },

    // 提现
    cashWithdrawal() {
      this.balanceForm.validateFields((err, values) => {
        // console.log('values=', values)
        if (!err) {
          let data = {
            user_name: values.user_name,
            user_phone: values.user_phone
          }
          CompanyApi.cashWithdrawal(data)
            .then(res => {
              if (res.code == 1) {
                this.$message.success('提现成功')
                // 刷新一下“可提现余额”
                this.getData()
              } else {
                this.$message.error(res.msg)
              }
              this.balanceVisible = !this.balanceVisible
            })
        }
      })
    },

    // 设置自定义推广位同步
    positionSync(record) {
      // console.log('设置自定义推广位同步=', record)
      this.$refs.cpSpace.show(record)
    },

  },
}
</script>
<style lang="less" scoped>
.table-operator {
  position: relative;
  display: flex;
  align-items: center;

  .alert {
    position: absolute;
    left: 560px;
  }

  p {
    margin-bottom: 0;
  }

  .commission {
    border-radius: 3px;
    box-shadow: 3px 2px 4px 1px #ccc, inset -1px -1px 2px 0 #ddd;
    padding: 3px;
    margin-left: 20px;

    p {
      // &:nth-child(1){
      //   // background-color: #fafafa;
      // }
      color: #333;
      text-align: center;
    }
  }
}
</style>
